exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oAmw8kRoa_t35fYbo935s{text-align:center}.l7sPhRD7xASOsTnPmsgMM{margin-bottom:1.25rem}._3RVYtawyeDLEKL0xWujSI5{margin-bottom:2rem}\n", ""]);

// exports
exports.locals = {
	"contactmodal": "oAmw8kRoa_t35fYbo935s",
	"headline": "l7sPhRD7xASOsTnPmsgMM",
	"content": "_3RVYtawyeDLEKL0xWujSI5"
};